<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-start pe-5">
                    <h3 class="fw-bold my-4">Data-driven transformation for better decision-making and business growth</h3>
                    <button class="btn-blue mt-5">Free Registration</button>
                </div>
                <div class="col-md-5 text-end">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">Data-driven transformation for better decision-making and business growth</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        In today’s digital world, data is the most valuable asset of any business. Proper data management and analysis can help organizations make smarter decisions, optimize their processes, and create new growth opportunities.
                        By providing innovative solutions in data management, advanced analytics, and business intelligence, we help you turn data into insights and effective strategies.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-start">
                        <h4 class="fw-bold">Challenges of Data Management and Analysis in Organizations</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>High volume of unstructured raw data: </strong>Many organizations have a large amount of unorganized data, making it difficult to analyze.
                                </li>
                                <li class="mt-3">
                                    <strong>Lack of a data-driven strategy: </strong>The absence of a clear plan for collecting, processing, and utilizing data leads to the loss of valuable information.
                                </li>
                                <li class="mt-3">
                                    <strong>Security and data protection challenges: </strong>Cyber threats and privacy breaches can harm an organization’s sensitive information.
                                </li>
                                <li class="mt-3">
                                    <strong>Difficulty in data analysis for rapid decision-making: </strong>The lack of proper data analysis tools prevents organizations from making smart decisions quickly.
                                </li>
                                <li class="mt-3">
                                    <strong>Lack of data integration across different departments: </strong>Dispersed data in various systems leads to reduced efficiency and lower accuracy in analyses.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">Our Solutions for Data Management and Analysis</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Design and Implementation of Data Management Strategy</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Developing a Data-Driven Roadmap for the Organization</li>
                                <li>Establishing Processes for Data Collection, Storage, and Processing</li>
                                <li>Optimizing Data Quality and Standardization</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img22.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Business Data Analysis and Business Intelligence (BI)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Utilizing Analytical Dashboards to Deliver Accurate Reports</li>
                                <li>Analyzing Market Trends and Predicting Customer Behavior</li>
                                <li>Integrating Data for Decision-Making Based on Real Insights</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Processing and Analyzing Big Data</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Utilizing Big Data Processing Technologies to Extract Valuable Insights</li>
                                <li>Analyzing Structured and Unstructured Data to Optimize Performance</li>
                                <li>Implementing Advanced Solutions for Storing and Processing Large Volumes of Data</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Data-Driven Solutions for Optimizing Organizational Processes</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Business Performance Analysis and Process Optimization</li>
                                <li>Leveraging Data to Enhance Customer Experience and Increase Loyalty</li>
                                <li>Developing Predictive Models for Risk Management and Rapid Decision-Making</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Implementing Artificial Intelligence and Machine Learning in Data Analysis</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Using Machine Learning Algorithms to Identify Patterns and Predict Trends</li>
                                <li>Analyzing Customer Behavior and Providing Personalized Recommendations</li>
                                <li>Designing Predictive Models to Increase Efficiency and Reduce Costs</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img7.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Data Security and Governance</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Implementing security solutions to protect data</li>
                                <li>Establishing data governance policies for access control and regulatory compliance</li>
                                <li>Assessing and managing risks related to data storage and transmission</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Data Integration and Development of Advanced Data Infrastructures</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Designing and implementing advanced databases</li>
                                <li>Creating data infrastructures to connect and integrate different systems</li>
                                <li>Optimizing data transfer processes and reducing storage costs</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img23.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-start">Results and Value Creation for Organizations</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increased accuracy in business decision-making </strong>through data-driven analyses
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img4.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Improved organizational efficiency and cost reduction </strong>through optimizing data processes
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhanced information security and reduced cyber risks </strong>through implementing protective solutions 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increased information security and reduced cyber risks </strong>by implementing protective solutions. 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Running.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Creating competitive advantage and discovering new opportunities </strong>through market data analysis. 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Business2.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Optimizing customer experience and increasing sales </strong>through precise analysis of customer behavior. 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-start">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>How can I properly manage my organization’s data?</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-start" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-start" style="line-height: 35px !important;">
                        We help you properly manage your organizational data by providing customized solutions—from data collection to processing and analysis.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>Is data analysis also beneficial for small businesses?</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, data analysis can help small businesses make better decisions and use information for growth and optimization.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>How can I use artificial intelligence to analyze my business data?</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        We implement artificial intelligence and machine learning models to analyze behavioral patterns, predict market trends, and provide personalized recommendations.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>Do your services also include training and implementation of data-driven systems?</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, in addition to providing consulting and data analysis, we also support you in the implementation and training of your organizational teams.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>How can I improve the security of my organization’s data?</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        We protect your information against threats by providing cybersecurity and data governance solutions and implement data management policies to enhance security.                        <br>
                        <br>
                        Data management and analysis are the keys to success in the digital world. For consultation and more information, please contact us.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
    direction: ltr;
}
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  right: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  right: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>